import consts from "@/consts.js";
import Request from './request';

async function fetchOne(id) {// 获取单个
    return Request('get', "api/material-categories/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/material-categories", data);
}

async function tree(data) {
    return Request('get', "api/material-categories/tree", data);
}

async function combineMaterialCategoryByShop(id) {
    return Request('get', "api/material-templates/get-combine-material-category/" + id);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/material-categories/edit?id=" + id, data);
    } else {
        return Request('post', "api/material-categories/add", data);
    }
}

async function del(id) {// 删除数据
    return Request('get', "api/material-categories/delete/", id ? { id: id } : {});
}

async function syncMaterialShowCategories() {//商品分类刷新成展示分类
    return Request('post', "api/material-categories/sync-material-show-categories")
}

export default {
    fetchOne,
    fetchAll,
    tree,
    combineMaterialCategoryByShop,
    save,
    del,
    syncMaterialShowCategories,
};